import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';

import Errors from './Errors';
import Fields from './Fields';
import SubmitButton from './SubmitButton';

const InnerForm = props => {
  const submit = find(props.items, field => field.inputType === 'submit');
  return (
    <div>
      <Errors errors={props.errors} />
      <form id={props.formId} onSubmit={props.handleSubmit}>
        <Fields
          items={props.items}
          onHandleChange={props.handleChange}
          setFieldValue={props.setFieldValue}
          onHandleBlur={props.handleBlur}
          values={props.values}
        />
        <SubmitButton
          id={submit.inputId}
          label={submit.label}
          formSubmitting={props.isSubmitting}
        />
      </form>
    </div>
  );
};

InnerForm.propTypes = {
  formId: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isSubmitting: PropTypes.bool.isRequired,
};

export default InnerForm;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Form/InnerForm/InnerForm.js